import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { User } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserService } from 'src/app/services/user/user.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-microchipping-your-pet',
  templateUrl: './microchipping-your-pet.component.html',
  styleUrls: ['./microchipping-your-pet.component.scss']
})
export class MicrochippingYourPetComponent implements OnInit {

  public alert: Alert = null;
  public loading = false;
  public pricingPlans = environment.stripePlans;
  public user: User | null = null;
  public isAuthenticated: boolean;
  public appPriceCardFeatureText: string[] = [
    'Instant email alert when your pet’s chip is scanned',
    '24/7 help & support via our dedicated hotline',
    'Unlimited changes to your details',
    'Annual keeper certificate',
    'Online account access and management',
    'Secure data storage'
  ]
  public appAlertPriceCardFeatureText: string[] = [
    'Instant contact when your missing pet’s chip is scanned',
    '24/7 help & support via our dedicated hotline',
    'Instant, personalised posters & social media posts',
    '20-mile missing pet report broadcast to vets, wardens and police',
    'SMS broadcast to other identi pet keepers in a 5 mile radius',
    'Keep your details up to date in our app so we can contact you faster'
  ];
  public brandName: string;
  public plan1FeatureText1: string;
  public plan1FeatureText2: string;
  public plan1FeatureText3: string;
  public plan1FeatureText4: string;
  public plan2FeatureText1: string;
  public plan2FeatureText2: string;
  public plan2FeatureText3: string;
  public plan2FeatureText4: string;
  public microchippingYourPetTrackPetsLocationText: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _helperService: HelperService,
    private _router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private authManager: AuthManagerService,
    public configService: ConfigService,
  ) {
    this.brandName = this.configService.getTextFromKey('brand-name');
    this.microchippingYourPetTrackPetsLocationText = this.configService.getTextFromKey('microchipping-your-pet-track-pets-location-text');
    this.plan1FeatureText1 = this.configService.getTextFromKey('1-plan-feature-text-1');
    this.plan1FeatureText2 = this.configService.getTextFromKey('1-plan-feature-text-2');
    this.plan1FeatureText3 = this.configService.getTextFromKey('1-plan-feature-text-3');
    this.plan1FeatureText4 = this.configService.getTextFromKey('1-plan-feature-text-4');
    this.plan2FeatureText1 = this.configService.getTextFromKey('2-plan-feature-text-1');
    this.plan2FeatureText2 = this.configService.getTextFromKey('2-plan-feature-text-2');
    this.plan2FeatureText3 = this.configService.getTextFromKey('2-plan-feature-text-3');
    this.plan2FeatureText4 = this.configService.getTextFromKey('2-plan-feature-text-4');
  }

  ngOnInit(): void {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
      });
    }
    
    this.appPriceCardFeatureText = [
      this.plan1FeatureText1, this.plan1FeatureText2, this.plan1FeatureText3, this.plan1FeatureText4
    ];
    this.appAlertPriceCardFeatureText = [
      this.plan2FeatureText1, this.plan2FeatureText2, this.plan2FeatureText3, this.plan2FeatureText4
    ];

    const queryParams = this._activatedRoute.snapshot.queryParams;

    if (queryParams && queryParams.section) {
      this._helperService.scrollToElementById(queryParams.section);
    }
  }

  public closeAlert() {
    this.alert = null;
  }

  public unauthorizedSelect(planId?: string) {
    switch (planId) {
      case environment.stripePlans.identibasePlus:
        this._router.navigate(['/identibase-plus']);
        break;
      case environment.stripePlans.identiAlertMonthly:
        this._router.navigate(['/identialert']);
        break;
      case environment.stripePlans.identiAlertAnnual:
        this._router.navigate(['/identialert']);
        break;
      default:
        this._router.navigate(['/identialert']);
    }
  }

}
